import React, { Component } from 'react';
import { TextInput } from '../shared/TextInput'
import Select from 'react-select';
import _ from 'lodash'

export default class KegSizes extends Component {

  kegSizeOptions = (kegSizes) => {
    let kegSizeOptionsArray = []
    kegSizes && kegSizes.map( kegSize => {
      kegSizeOptionsArray.push({
        value: kegSize['id'],
        label: _.startCase(kegSize['size'])
      })
    })
    return kegSizeOptionsArray
  }

  render() {
    return (
      <div>
        <label>
          Available Keg Sizes
        </label>
        <Select
          className='km-select'
          name="form-field-name"
          style={
            {
              'color': '#333',
              'backgroundColor': '#F9F9F9',
              'outline': 'none',
              'borderColor':'none',
              'width': 315,
              'height': 40,
              'marginBottom': 23
            }
          }
          className={'brewery-keg-sizes'}
          multi={true}
          value={ this.props.selectedKegSizes }
          optionClassName='km-select'
          onChange={ this.props.handleKegSizes }
          options={ this.kegSizeOptions(this.props.allKegSizes) }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/KegSizes.jsx